import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Transforms the analytics_technologies criteria from WooRank API response
 * @param {Object} analyticsTechnologiesCriteria - criteria.analytics_technologies
 * @returns {Object} - Transformed analytics technologies data for React components
 */
export const transformAnalyticsTechnologies = (analyticsTechnologiesCriteria) => {
  if (!analyticsTechnologiesCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Analytics Technologies were found.',
      data: null,
    };
  }

  const data = analyticsTechnologiesCriteria?.data || {};
  const wooRankStatus = analyticsTechnologiesCriteria?.status || 'neutral';
  const importance = analyticsTechnologiesCriteria?.importance || 0;
  const solvability = analyticsTechnologiesCriteria?.solvability || 0;

  const items = (data?.technologies || [])
    .map((t) => ({
      name: t?.app || '',
    }))
    .filter((t) => Boolean(t.name));

  const isEmpty = items.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No Analytics Technologies were found.' : null,
    data: isEmpty ? null : { items },
  };
};

export default transformAnalyticsTechnologies;


